






















import Vue from 'vue'
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import Service from '@/modules/reservation/model/Service';
import {Colors, notify} from '@/modules/core/notification';

/**
 * Dialogo de confirmación para la eliminación de un servicio de reservas
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class ConfirmDeleteReservationService extends Vue {
    /**
     * Controla la visibilidad del dialogo
     *
     * @var { boolean }
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    /**
     * Servicio que será eliminado
     */
    @Prop({type: Service, default: () => new Service()})
    public service: Service

    /**
     * Indica si la aplicación esta eliminando el servicio
     */
    public deleting = false

    /**
     * Solicita a la aplicación la eliminación del servicio actualmente seleccionado
     * por el usuario
     */
    public async remove () {
        this.deleting = true
        await this.$store.dispatch('reservation/deleteService', this.service.id)


        this.deleting = false
        this.$emit('input', false)
        // Lanza un evento indicando que el servicio ha sido eliminado
        this.$emit('deleted', this.service.id)
        notify(`El servicio ${this.service.name} se ha eliminado correctamente`)
    }

    /**
     * Cualquier error producido es capturado y notificado al usuario. El componente
     * vuelve a su estado inicial.
     *
     * @param error
     */
    public errorCaptured (error: Error) {
        this.deleting = false
        this.$emit('input', false)

        notify(error.message, Colors.Error)
    }
}
